/** @type {import('next-i18next').UserConfig} */
const { DEFAULT_LANGUAGE, LANGUAGES, SUPPORTED_LANGUAGES } = require('@inflearn/i18n-tools');

module.exports = {
  i18n: {
    locales: LANGUAGES,
    localeDetection: false,
    defaultLocale: DEFAULT_LANGUAGE,
    localeSubPaths: SUPPORTED_LANGUAGES,
    debug: false,
    domains: [
      {
        domain: 'inflearn.com',
        defaultLocale: DEFAULT_LANGUAGE,
      },
    ],
  },
  // locale JSON 수정 시 개발 서버가 메모리 캐시를 쓰지 않도록
  reloadOnPrerender: process.env.NODE_ENV === 'development',
};
